<template>
    <div class="accept-page">
        <div class="head2">
            <div class="description" @click="goToPrinciple"><span>收寄标准说明</span>></div>
            <div class="address">
                <div @click="toggleSelector('origin')">
                    <span class="sender">寄</span>
                    <p class="input" :class="{ active: areaNameOrigin }">{{ areaNameOrigin || '请选择始发地国家/地区名称' }}</p>
                    <!--<input type="text" readonly placeholder="请选择" :value="selectedOrigin.cnName">-->
                    <icon class="ico-right" name="right"></icon>
                </div>
                <div @click="toggleSelector('dest')">
                    <span class="receiver">收</span>
                    <p class="input" :class="{ active: areaNameDest }">{{ areaNameDest || '请选择目的地国家/地区名称' }}</p>
                    <!--<input type="text" readonly placeholder="请选择" :value="selectedDest.cnName">-->
                    <icon class="ico-right" name="right"></icon>
                </div>
                <img src="@/assets/images/ico/v-dot.png" alt="图标" />
            </div>
            <div class="article">
                <p class="label">托寄物</p>
                <p class="input-wrapper">
                    <input v-model="article" type="text" placeholder="请输入，例如：电池" maxlength="10" />
                    <span>{{ article.length }}/10</span>
                </p>
            </div>
            <p class="button-wrapper">
                <button type="button" class="primary-btn" :disabled="!(areaNameOrigin && areaNameDest && article)" @click="query()">查询</button>
            </p>
            <p v-show="selectedDest.info" class="info">{{ selectedDest.info }}</p>
        </div>
        <!-- 城市选择 -->
        <overlay
            :isShow.sync="isShowSelector"
            :finished.sync="selectCompleted"
            :enableBtn="enableBtn"
            :hasValid="hasSelectValidator"
            :cbValid="validSelector"
        >
            <h3 class="head">地区选择</h3>
            <ul class="rgn-tab">
                <li v-for="(item, idx) in regionTabs" :key="item.id" @touchstart.stop="toggleTab(idx)">
                    <div class="btn-tab" :class="{ active: regionTabIndex === idx }">{{ item.name }}</div>
                </li>
            </ul>
            <!-- <div class="search-form">
				<input type="text" v-model="inputTxt" class="search" :placeholder="placeholderTxt" @input="inputChange">
				<i class="icon-search"></i>
				<i class="icon-close" v-if="inputTxt" @click.prevent="clear"></i>
			</div> -->
            <form @submit.prevent="submitSelect">
                <div v-if="!searchAddressList.length">
                    <div v-if="regionTabIndex === 0">
                        <area-inland
                            page="accept"
                            :area="area"
                            :isDest="type !== 'origin'"
                            :updateAreaCode="updateAreaCode"
                            :updateArea="updateArea"
                            :updateSelect="updateSelect"
                        />
                    </div>
                    <div v-if="regionTabIndex === 1">
                        <area-hmt
                            page="accept"
                            :area="area"
                            :isDest="type !== 'origin'"
                            :updateAreaCode="updateAreaCode"
                            :updateArea="updateArea"
                            :updateSelect="updateSelect"
                            :provinces="intlProvinces"
                        />
                    </div>
                    <div v-if="regionTabIndex === 2">
                        <area-intl
                            :area="area"
                            page="accept"
                            :isDest="type !== 'origin'"
                            :updateArea="updateArea"
                            :input="inputTxt"
                            :updateAreaCode="updateAreaCode"
                            :zipCode="zipCode"
                            :updateZipCode="val => (zipCode = val)"
                            :updateSelect="updateSelect"
                            :provinces="intlProvinces"
                        />
                    </div>
                </div>
                <ul v-else class="search-address-region">
                    <!-- eslint-disable-next-line vue/no-v-html -->
                    <li
                        v-for="(item, index) in searchAddressList"
                        :key="index"
                        :class="{ active: index === selectedItemIndex }"
                        @click="selectedSearchAddress(item, index)"
                        v-html="item.html"
                    ></li>
                </ul>
            </form>
            <slot slot="button" slot-scope="props">
                <div ref="btnConfirm" class="btn-confirm" :class="{ active: props.active }">
                    <span>确认</span>
                </div>
            </slot>
        </overlay>
        <div v-show="showResult">
            <p v-if="result.length === 0" class="no-result">未搜索到的物品以收派员上门核实为准</p>
            <result-popup v-else v-model="showPopResult" position="bottom" class="result">
                <p class="title">
                    <span>查询结果</span>
                    <span class="close" @click="showPopResult = false">
                        <icon name="close"></icon>
                    </span>
                </p>
                <p class="warmTip">温馨提示：因各地区有差异，最终请以快递员上门确认为准！</p>
                <div class="result-wrap">
                    <div v-for="item in result" :key="item.searchKey" class="result-item">
                        <div class="item">
                            <div class="item-title">托寄物名称：</div>
                            <div class="item-des">{{ item.searchKey }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">收寄要求：</div>
                            <div class="item-des">{{ expressRequireNameObj[item.finalExpressRequireCode] }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">运输条件：</div>
                            <div class="item-des">陆运：{{ expressRequireNameObj[item.finalExpressRequireRoad] }}</div>
                            <div class="item-des">空运：{{ expressRequireNameObj[item.finalExpressRequireAir] }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">收寄说明：</div>
                            <div class="item-des">{{ item.finalExpressInstructions }}</div>
                            <!-- <div class="item-des">{{ item.expressInstructionsTh }}</div>
                            <div class="item-des">{{ item.expressInstructionsEn }}</div> -->
                        </div>
                    </div>
                </div>
                <div class="result-btn">
                    <div class="btn" @click="showPopResult = false">确定</div>
                </div>
            </result-popup>
        </div>
    </div>
</template>
<script>
import { mapMutations } from 'vuex'
import { RegionGroup } from '@/constant/common'
import ibuCountry from '@/constant/ibuCountry'
import InlandCitySelector from '@/components/citySelector/area-inland'
import IntlCitySelector from '@/components/citySelector/area-intl'
import HMTCitySelector from '@/components/citySelector/area-hmt'
import Overlay from '@/components/citySelector/overlay/'
import ajax from '../../api/ajax'
import { Popup, Indicator } from 'mint-ui'
import mixCitySelector from '@/components/citySelector/mixin'
import globalVar from '@/util/globalVar'
import UIP from '@/util/uip.js'
import { getHighHtml } from '@/util/util.js'

const expressRequireNameObj = {
    ExpressRequireAllow: '可收寄',
    ExpressRequireProhibit: '不可收寄',
    ExpressRequireRestrict: '有条件收寄'
}
export default {
    name: 'Accept',
    components: {
        'area-inland': InlandCitySelector,
        'area-intl': IntlCitySelector,
        'area-hmt': HMTCitySelector,
        overlay: Overlay,
        'result-popup': Popup
    },
    mixins: [mixCitySelector],
    props: {
        // 是否隐藏头部
        noHead: {
            type: String,
            default: 'false'
        },
        // 是否隐藏底部
        noFooter: {
            type: String,
            default: 'false'
        }
    },
    data() {
        return {
            // 托寄条件字典
            expressRequireNameObj,
            isShowSelector: false, // 是否显示城市选择框
            isShowSelector2: false,
            enableBtn: false, // 选择结束，激活按钮
            selectCompleted: false, // 选择是否完成
            regionTabIndex: 0, // 范围选择项(大陆、港澳台、国际)
            regionTabIndexO: 0,
            regionTabIndexD: 0,
            selectorValidResult: '', // 选择器验证结果
            isShowResult: false,
            rangeData: {
                unavailableRegions: [], // 不服务地区
                normalRegions: [], // 正常收送地区
                abnormalRegions: [], // 特别收送地区
                type: '' // ALL_REGION,全境提供服务; PART_REGION,部分地区提供服务;
            },
            areaName: '国家/地区选择', // 选择地址名
            zipCode: '',
            areaCodeOrigin: '',
            areaCodeDest: '',
            rateCodeOrigin: '',
            rateCodeDest: '',
            areaNameOrigin: '',
            areaNameDest: '',
            countryList: [], // 同步cx已开放的国际国家json数据
            intlProvinces: [], // 国际城市信息
            inputTxt: '', // 搜索框输入文案
            searchAddressList: [], // 搜索结果列表
            selectedItemIndex: -1, // 搜索结果选中索引
            article: '', // 物品
            buttonDisabled: true,
            selectedDest: {
                cnName: '',
                shortName: '',
                info: ''
            },
            area: {},
            areaOrigin: {},
            areaDest: {},
            type: 'origin',
            result: [],
            showResult: false,
            showPopResult: false,
            hasNoMore: true
        }
    },
    computed: {
        selectedOriginName() {
            return ''
        },
        selectedDestName() {
            return ''
        },
        regionTabs() {
            return RegionGroup.regionTabs
        },
        isAllService() {
            return this.rangeData.type === 'ALL_REGION'
        },
        unavailableRegionsNames() {
            const names = this.rangeData.unavailableRegions.map(item => item.name)
            return names.join('-')
        },
        isInternational() {
            return this.regionTabIndex === 2
        },
        isUSA() {
            return this.areaCode === 'A000001000'
        },
        hasSelectValidator: {
            // 选择器是否有验证规则
            get() {
                return this.isInternational
            }
        },
        /**
         * 根据范围选择项动态匹配输入框默认文案
         */
        placeholderTxt() {
            return (
                new Map([
                    [0, '请输入地区名进行搜索'],
                    [1, '请输入地区名进行搜索'],
                    [2, '请输入国家名进行搜索']
                ]).get(this.regionTabIndex) || '请输入地区名进行搜索'
            )
        },
        /**
         * 行政区的 regionKey
         */
        regionKey() {
            return (
                new Map([
                    [0, 'local_region_cn_sc'],
                    [1, 'local_region_hk_mo_tw_sc'],
                    [2, 'local_ibu_hotcounties_sc']
                ]).get(this.regionTabIndex) || 'local_region_cn_sc'
            )
        }
    },
    watch: {
        selectCompleted(val) {
            if (val && !this.isInternational) {
                // this.getRange()
            }
        },
        inputTxt(val) {
            if (!val) {
                this.clear()
            }
        },
        regionTabIndex(val) {
            if (this.inputTxt) {
                this.inputChange()
            }
        }
    },
    created() {
        this.setTitle('收寄标准查询')
        this.setShowHeader(!(this.noHead === 'true'))
        this.setShowFooter(!(this.noFooter === 'true'))
        // 获取国外已开放国家js数据
        this.countryList = ibuCountry.countryList
        // 取出国家code码，与接口返回的国际国家数据取交集，使用接口返回的国家数据
        const countryCodeList = []
        this.countryList.forEach(value => {
            countryCodeList.push(value.code)
        })
        this.getRegion({ code: 'A000000000' }).then(provinces => {
            const countryArray = provinces.filter(value => countryCodeList.indexOf(value.rateCode) > -1)
            this.intlProvinces = countryArray
        })
        this.setShowCustomer(true)
    },
    methods: {
        ...mapMutations('range', {
            setSelectorValid: 'setSelectorValid',
            setAreaData: 'setAreaData'
        }),
        ...mapMutations(['setShowCustomer']),
        ...mapMutations({
            setTitle: 'setTitle',
            setShowHeader: 'setShowHeader',
            setShowFooter: 'setShowFooter'
        }),
        getMore() {
            this.query({
                page: this.currentPage + 1,
                showLoading: false,
                getMore: true
            })
        },
        /**
         * 模糊匹配
         */
        async inputChange() {
            if (this.inputTxt) {
                const options = {
                    regionKey: this.regionKey,
                    count: '1000'
                }
                // this.searchAddressList = await this.$I.region.search(this.inputTxt, options)
                this.searchAddressList = await UIP.interface.region.search(this.inputTxt, options)
                this.searchAddressList.forEach(item => {
                    const str = [item.province, item.city, item.county].filter(item => !!item).join('-')
                    item.html = getHighHtml(str, this.inputTxt)
                    item.cityCode = item.countyAreaCode || ''
                    item.countyCode = item.countyAreaCode || ''
                    item.locationCode = item.countyLocationCode || item.cityLocationCode || item.provinceLocationCode || ''
                    item.provinceCode = item.provinceAreaCode || ''
                })
            }
        },
        /**
         * 清空搜索数据
         */
        clear() {
            this.selectedItemIndex = -1
            this.searchAddressList = []
            this.inputTxt = ''
        },
        /**
         * 选中某一项返回接口查询结果
         */
        selectedSearchAddress(item, index) {
            this.enableBtn = true
            this.selectedItemIndex = index
            this.areaCode = item.countyCode
            this.areaName = `${item.province}-${item.city}-${item.county}`
        },
        submitSelect() {
            const event = document.createEvent('Events')
            event.initEvent('touchstart', true, true)
            this.$refs.btnConfirm.dispatchEvent(event)
        },
        async validSelector() {
            let valid = false
            if (this.isInternational) {
                const code = this.zipCode
                valid = await this.validSelectorIntl(code)
            }
            if (!valid) {
                // 验证没有通过， 重置状态（选择未完成）
                this.selectCompleted = false
                this.enableBtn = false
            }
            this.setSelectorValid(valid)
            return valid
        },
        async validSelectorIntl(code) {
            /**
             * @author 80004302
             * @desc 国际范围查询邮编后端验证ZipCode, 验证失败，则重置选择组件的验证状态
             */
            // let valid = false
            // valid = await this.getGlobalRange(code)
            // if(!valid) {
            // 	this.areaName = '国家/地区选择'
            // }
            return true
        },
        updateAreaCode({ code, areaName, rateCode }) {
            if (this.type === 'origin') {
                this.areaCodeOrigin = code
                this.rateCodeOrigin = rateCode
                this.areaNameOrigin = areaName
            } else {
                this.areaCodeDest = code
                this.rateCodeDest = rateCode
                this.areaNameDest = areaName
            }
        },
        updateArea(data) {
            if (this.type === 'origin') {
                this.areaOrigin = data
            } else {
                this.areaDest = data
            }
        },
        updateSelect(val) {
            this.enableBtn = !!val
        },
        toggleTab(index) {
            if (this.regionTabIndex !== index) {
                this.enableBtn = false
            }
            if (this.type === 'origin') {
                this.regionTabIndexO = index
                this.regionTabIndex = index
            } else {
                this.regionTabIndexD = index
                this.regionTabIndex = index
            }
            this.selectedItemIndex = -1
            // this.setAreaData({})
        },
        toggleSelector(type) {
            this.type = type
            if (this.type === 'origin') {
                this.area = this.areaOrigin
                this.regionTabIndex = this.regionTabIndexO
            } else {
                if (!this.areaNameOrigin) {
                    return this.$toast('请选择始发地国家/地区名称')
                }
                this.area = this.areaDest
                this.regionTabIndex = this.regionTabIndexD
            }
            this.isShowSelector = true
            this.enableBtn = false
        },
        getRange() {
            const areaCode = this.areaCode
            Indicator.open()
            ajax.getInternalRange({
                params: {
                    areaCode
                }
            })
                .then(res => {
                    this.rangeData = res.data
                    this.isShowResult = true
                })
                .catch(() => {
                    this.isShowResult = false
                })
                .finally(() => {
                    Indicator.close()
                })
        },
        async getGlobalRange(code) {
            let valid = false
            const areaCode = this.areaCode
            Indicator.open()
            try {
                const res = await ajax
                    .getGlobalRange({
                        params: {
                            areaCode,
                            zipCode: code
                        }
                    })
                    .catch(err => {
                        if (err.response && (err.response.status === 404 || err.response.status === 403 || err.response.status === 0)) {
                            this.$toast('对不起，查询不到数据')
                        } else {
                            this.$toast('服务器暂不可用，请稍后再试')
                        }
                    })
                this.rangeData = res.data
                let areaName = [this.areaName, this.zipCode].join('-')
                if (areaName.endsWith('-')) {
                    areaName = areaName.slice(0, -1)
                }
                this.areaName = areaName
                valid = true
                this.isShowResult = true
            } catch (e) {
                valid = false
                this.isShowResult = false
            }
            Indicator.close()
            return valid
        },
        async getRegion({ code, level = -1 }) {
            // 获取国际省份信息
            const { data } = await ajax.getOriginRegions({
                lang: 'sc',
                regiion: 'cn',
                translate: 'sc',
                data: {
                    code
                },
                params: {
                    level: -1
                }
            })
            return data
        },
        goToPrinciple() {
            this.$router.push({ name: 'acceptPrinciple', query: { noHead: String(this.noHead) } })
        },
        /**
         * @Author 80002393
         * @Description 获取标准
         * @parma
         * @Date 2019/9/11
         */
        query({ page = 1, showLoading = true, getMore = false } = {}) {
            // 去掉始发地和目的地不能是同一个地址的限制
            // if(this.areaCodeOrigin === this.areaCodeDest) return this.$toast('始发地与目的地不能选择相同国家/地区，请重新选择')
            let result = []
            showLoading && Indicator.open(globalVar.loadingMsg)
            ajax.getAcceptResult({
                params: {
                    srcCountryCode: [1, 2].indexOf(this.regionTabIndexO) > -1 ? this.rateCodeOrigin : 'CN',
                    destCountryCode: [1, 2].indexOf(this.regionTabIndexD) > -1 ? this.rateCodeDest : 'CN',
                    srcCityCode: [0, 1].indexOf(this.regionTabIndexO) > -1 ? this.rateCodeOrigin : '',
                    destCityCode: [0, 1].indexOf(this.regionTabIndexD) > -1 ? this.rateCodeDest : '',
                    isAccurate: 0,
                    commodityName: this.article,
                    currentPage: page,
                    pageSize: 10
                }
            })
                .then(res => {
                    if (Number(res.data.code) === 0 && res.data.result && res.data.result.length > 0) {
                        result = res.data.result
                        // let resultCopy = []
                        // if(result) {
                        //     result.forEach(item => {
                        //         if(item.items && item.items.length) {
                        //             resultCopy = [...resultCopy, ...item.items]
                        //         }
                        //     })
                        // }
                        // result = resultCopy
                        this.showPopResult = true
                        if (res.data.page) {
                            this.currentPage = parseInt(res.data.page.currentPage)
                            this.totalPage = parseInt(res.data.page.totalPage)
                        }
                    } else {
                        // eslint-disable-next-line no-undef
                        reject()
                    }
                })
                .catch(() => {
                    result = []
                })
                .finally(() => {
                    this.showResult = true
                    showLoading && Indicator.close()
                    if (getMore) {
                        this.result = this.result.concat(result)
                        this.$refs.loadmore.onBottomLoaded()
                    } else {
                        this.result = result
                    }
                })
        }
    }
}
</script>

<style lang="scss" scoped>
.accept-page {
    background: $gray-lighter;
    max-height: calc(100% - 0.98rem);
    .result-btn {
        background: #ffffff;
        border: 1px solid #ebebeb;
        height: 130px;
        padding: 22px 0;
        .btn {
            height: 86px;
            line-height: 86px;
            margin: auto;
            width: 300px;
            background: #dc1e32;
            border-radius: 100px;
            font-size: 34px;
            color: #ffffff;
            text-align: center;
        }
    }
    .result-wrap {
        overflow: auto;
        -webkit-overflow-scrolling: touch;
        .result-item {
            background: #f9f9f9;
            border: 1px solid #f3f3f3;
            border-radius: 8px;
            margin: 44px;
            padding: 23px;
            .item {
                .item-title {
                    margin-top: 18px;
                    font-size: 28px;
                    font-weight: bold;
                    color: #333333;
                    letter-spacing: 0;
                    line-height: 44px;
                }
                .item-des {
                    font-size: 26px;
                    color: #151515;
                    letter-spacing: 0;
                    line-height: 44px;
                }
            }
        }
    }
    .head2 {
        background: $white;
    }
    .description {
        font-size: 0.24rem;
        display: block;
        height: 0.54rem;
        line-height: 0.54rem;
        text-align: right;
        padding-right: 0.55rem;
        background: $yellow-dark;
        color: $white;
        opacity: 0.7;
        span {
            padding-right: 0.2rem;
        }
    }
    .address {
        margin: 0 0.24rem;
        display: flex;
        flex-direction: column;
        background: $white;
        border-radius: 0.04rem;
        box-shadow: 0 0.04rem 0.32rem 0 rgba(0, 0, 0, 0.08);
        position: relative;
        & > div {
            height: 1.25rem;
            position: relative;
            display: flex;
            align-items: center;
            span {
                display: inline-flex;
                font-size: 0.24rem;
                font-weight: bold;
                width: 0.36rem;
                height: 0.36rem;
                align-items: center;
                justify-content: center;
                border-radius: 0.04rem;
                margin: 0 0.3rem;
                &.sender {
                    background: $black;
                    color: $white;
                }
                &.receiver {
                    background: $red;
                    color: $white;
                }
            }
            .input {
                height: 100%;
                display: flex;
                align-items: center;
                flex: 1;
                color: $gray-light;
                &.active {
                    color: $black;
                }
            }
            &:first-of-type {
                .input {
                    border-bottom: 0.02rem solid $gray-lighter;
                }
            }
        }
        .ico-right {
            height: 0.2rem;
            position: absolute;
            right: 0.3rem;
            top: 0.5rem;
            color: $gray-light;
        }
        img {
            position: absolute;
            height: 0.6rem;
            top: 0.95rem;
            left: 0.46rem;
        }
    }
    .sel-reigin {
        padding: 0 0.3rem;
        line-height: 1rem;
        background: #fff;
        label {
            display: flex;
            align-items: baseline;
            position: relative;
            top: -0.6rem;
        }
        .title {
            font-weight: 600;
        }
        .txt {
            background: #fff;
            display: inline-block;
            color: #868686;
            text-align: left;
            flex: 1;
            margin-right: 0.2rem;
            border: 1px solid #d9d9d9;
            border-radius: 0.08rem;
            box-shadow: 0 0.1rem 0.24rem 0 rgba(0, 0, 0, 0.06);
            padding-left: 0.24rem;
            padding-right: 0.3rem;
            &.active {
                color: $black;
            }
        }
        .caret-right {
            position: absolute;
            top: 50%;
            right: 0.5rem;
            margin-top: -0.06rem;
            width: 0;
            height: 0;
            border: 0.11rem solid transparent;
            border-top: 0.11rem solid black;
        }
    }
    .article {
        margin-top: 0.44rem;
        .label {
            font-size: 0.24rem;
            font-weight: bold;
            color: #666666;
            padding: 0 0.54rem;
        }
        .input-wrapper {
            margin: 0 auto;
            margin-top: 0.22rem;
            width: 6.54rem;
            position: relative;
            span {
                position: absolute;
                right: 0.21rem;
                top: 0.16rem;
            }
        }
        input {
            display: block;
            border: none;
            height: 0.76rem;
            font-size: 0.28rem;
            border-radius: 0.06rem;
            padding: 0 0.21rem;
            background: #fafafb;
        }
    }
    .button-wrapper {
        text-align: center;
        margin-top: 0.48rem;
        padding-bottom: 0.51rem;
    }
    .select {
        width: 100%;
        font-size: 0.3rem;
        .title {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
        }
        .top {
            height: 0.84rem;
            color: #111111;
            padding: 0 0.48rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .svg-icon {
                width: 0.4rem;
            }
            a {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 0.8rem;
                height: 0.8rem;
            }
        }
        .bottom {
            height: 0.84rem;
            display: flex;
            padding-left: 0.64rem;
            color: $red;
            align-items: stretch;
            border-bottom: 0.04rem solid $gray-lighter;
            span {
                display: flex;
                align-items: center;
                border-bottom: 0.04rem solid $red;
                position: relative;
                top: 0.04rem;
            }
        }
        .error {
            height: 30vh;
            line-height: 30vh;
            text-align: center;
        }
    }
    .overlay-service {
        position: fixed;
        top: 70%;
        right: 0.1rem;
        width: 1rem;
        height: 1rem;
        background-color: #fff;
        box-shadow: 0 0 0.13rem 3px rgba(0, 0, 0, 0.1);
        padding: 0.1rem 0;
        z-index: 10;
        >>> a {
            display: block;
            width: 100%;
        }
        p {
            font-size: 5px;
            color: 666;
            &::before {
                content: '';
                display: block;
                width: 0.5rem;
                height: 0.5rem;
                margin: 0 0 0 auto;
                background: url('~@/assets/images/logo/sf-logo.png') 0 0 / 0.4rem 0.4rem no-repeat;
            }
        }
    }
    .rgn-tab {
        li {
            display: inline-block;
            width: 33.3%;
            text-align: center;
            line-height: 2;
            padding: 0.2rem;
        }
        .btn-tab {
            width: 80%;
            margin: 0 auto;
            background: #fff;
            border-radius: 0.3rem;
            font-size: 0.26rem;
            box-sizing: border-box;
            border: solid 0.01rem #e4e4e4;
            &.active {
                color: #dc1e32;
                border: solid 0.01rem #dc1e32;
                background: #fff;
            }
        }
    }
    .rst-range {
        padding: 0 0.71rem 0 0.64rem;
        background: $white;
        .tip {
            font-size: 0.26rem;
            line-height: 0.52rem;
            color: #888888;
            text-align: left;
            &.all-range {
                font-size: 0.3rem;
                line-height: 0.6rem;
                color: #0dbf0b;
                .icon-all-range {
                    display: inline-block;
                    vertical-align: middle;
                    width: 0.36rem;
                    height: 0.36rem;
                    background: url('~@/assets/svg/all-range.svg') center / cover;
                    margin-right: 0.11rem;
                    margin-top: -0.06rem;
                }
            }
            &.part-range {
                font-size: 0.28rem;
                line-height: 0.6rem;
                color: #dc1e32;
                .icon-part-range {
                    display: inline-block;
                    vertical-align: middle;
                    width: 0.36rem;
                    height: 0.36rem;
                    background: url('~@/assets/svg/part-range.svg') center / cover;
                    margin-right: 0.11rem;
                    margin-top: -0.06rem;
                }
            }
        }
        .pane {
            margin-bottom: 0 0.3rem;
        }
    }
    h3 {
        padding: 0.3rem;
        text-indent: 2ch;
        font-size: 0.3rem;
        color: #111111;
        font-weight: 800;
        box-shadow: 0 1px 0 0 #f2f2f2;
    }
    h5 {
        font-size: 0.26rem;
        color: #333333;
        font-weight: bold;
        line-height: 3;
        width: 100%;
    }
    -webkit-overflow-scrolling: touch;
}
.btn-confirm {
    padding: 0.2rem 0.5rem;
    >>> span {
        display: inline-block;
        width: 100%;
        border-radius: 0.48rem;
        text-align: center;
        color: #fff;
        font: bold 0.34rem/3 YaHei;
        letter-spacing: 0.5rem;
        text-indent: 0.5rem;
        background: rgba(0, 0, 0, 0.3);
    }
    &.active {
        >>> span {
            background: #dc1e32;
            color: #ffffff;
        }
    }
}
::-webkit-scrollbar {
    display: none;
}
.search-form {
    position: relative;
    margin: 0.2rem 0.3rem 0;
    width: calc(100% - 0.6rem);
    height: 0.64rem;
    .icon-search {
        position: absolute;
        display: inline-block;
        left: 0.2rem;
        top: 0.18rem;
        width: 0.32rem;
        height: 0.32rem;
        background: url('~@/assets/images/ico/icon-search-gray.png') no-repeat;
        background-size: cover;
    }
    .icon-close {
        position: absolute;
        display: inline-block;
        right: 0.3rem;
        top: 0.18rem;
        width: 0.3rem;
        height: 0.3rem;
        background: url('~@/assets/images/ico/icon-close-new.png') no-repeat;
        background-size: cover;
    }
}
input[type='text'] {
    position: relative;
    padding: 0 0.7rem 0 0.57rem;
    border: none;
    font-size: 0.26rem;
    color: $black;
    background-color: $bg-color;
    border-radius: 0.32rem;
    line-height: 0.64rem;
}
.search-address-region {
    padding-top: 0.32rem;
    max-height: 7rem;
    overflow-y: scroll;
    li {
        width: 100%;
        min-height: 0.96rem;
        line-height: 0.96rem;
        padding: 0.26rem 0.44rem;
        font-size: 0.3rem;
        line-height: 0.42rem;
        &:nth-child(odd) {
            background-color: #f9f9f9;
        }
        &.active {
            color: rgba(226, 12, 12, 0.842);
            &::before {
                content: '\2714';
                position: relative;
                float: right;
            }
        }
    }
}
.search-address-null {
    padding-top: 0.32rem;
    span {
        display: inline-block;
        width: 100%;
        line-height: 0.96rem;
        padding: 0.26rem 0.44rem;
        font-size: 0.3rem;
        line-height: 0.42rem;
    }
}
.result {
    width: 100%;
    max-height: 100%;
    background: $white;
    display: flex;
    flex-direction: column;
    .warmTip {
        padding: 0 0.32rem;
        padding-bottom: 22px;
        font-size: 0.22rem;
        color: $red;
    }
    .title {
        font-size: 0.3rem;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-shrink: 0;
        height: 0.84rem;
        color: #111111;
        padding: 0 0.48rem;
        .svg-icon {
            width: 0.4rem;
        }
        .close {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 0.8rem;
            height: 0.8rem;
        }
    }
}
table {
    width: 100%;
    font-size: 0.28rem;
    td {
        width: 25%;
        text-align: center;
        padding: 0.15rem 0;
        border: 0.01rem solid $gray-lighter;
    }
    tr {
        &:nth-of-type(odd) {
            background: #fcfcfc;
        }
    }
}
.table-title-wrapper {
    margin-top: 0.21rem;
    height: 0.95rem;
    box-sizing: content-box;
}
.table-title {
    height: 0.95rem;
    display: flex;
    align-items: stretch;
    background: #fcfcfc;
    font-size: 0.3rem;
    font-weight: bold;
    border-top: 0.01rem solid $gray-lighter;
    span {
        width: 25%;
        display: flex;
        align-items: center;
        justify-content: center;
        &:not(:first-of-type) {
            border-left: 0.01rem solid $gray-lighter;
        }
    }
}
.no-result {
    margin-top: 0.27rem;
    padding: 0.27rem 0.25rem;
    background: $white;
    color: $red;
}
.load-more-wrapper {
    flex: 1;
    overflow: auto;
}
.load-tip {
    text-align: center;
    height: 0.7rem;
    line-height: 0.7rem;
}
</style>

<style lang="scss">
.search-address-region {
    li {
        i {
            display: inline-block;
            color: $red;
            font-style: normal;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/accept/index.vue